import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import { ToastContainer } from "react-toastify";
import LogisticInqForm from "@/modules/frontend/components/Inquiry/LogisticInqForm";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import { motion } from "framer-motion";

const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  return (<>
    <section className="inquiry-from-wrape">
      <SeoHelmet
        title={seoConfig.inquiryLogistic.title}
        description={seoConfig.inquiryLogistic.description}
        keywords={seoConfig.inquiryLogistic.keywords}
        author={seoConfig.inquiryLogistic.author}
      />
      {/* inner page content START */}
      <div className="inner-page-content-wrape">
        <div className="stepper-wrape">
          <div className="container">
            <div className="row">
              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                <motion.div className="step animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >
                  <motion.div className="icon animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >
                    <i className="sprite submit"></i>
                  </motion.div>
                  <div className="detail">
                    <motion.h6 className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.2}
                      variants={fadeUpVariant}
                    >Submit your requirements effortlessly</motion.h6>
                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.2}
                      variants={fadeUpVariant}
                    >Be as detailed as possible.</motion.p>
                  </div>
                </motion.div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                <motion.div className="step animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >
                  <motion.div className="icon animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >
                    <i className="sprite request"></i>
                  </motion.div>
                  <div className="detail">
                    <motion.h6 className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.2}
                      variants={fadeUpVariant}
                    >We forward your request to verified Logistics Partners</motion.h6>
                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.2}
                      variants={fadeUpVariant}
                    >AI-based matching based on your content</motion.p>
                  </div>
                </motion.div>
              </div>
              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                <motion.div className="step arrow-none animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >
                  <motion.div className="icon animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.2}
                    variants={fadeUpVariant}>
                    <i className="sprite quote"></i>
                  </motion.div>
                  <div className="detail">
                    <motion.h6 className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.2}
                      variants={fadeUpVariant}
                    >Receive quotes from trusted Logistics Partners</motion.h6>
                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.2}
                      variants={fadeUpVariant}
                    >Receive first results within 1 working day</motion.p>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
        <div className='container inquiry-form-section'>
          <div className='row'>
            <div className="col-xxl-2 col-xl-2 col-lg-1 col-md-12"></div>
            <div className="col-xxl-8 col-xl-8 col-lg-10 col-md-12">
              <LogisticInqForm />
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
      {/* inner page content END */}
    </section>
    <ConsentManager data={""} />
  </>)
}

export default Index;